import React from 'react'

import DOMPurify from 'dompurify';

import { gql, useApolloClient } from '@apollo/client';
import {
    Button,
    FormGroup,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControlLabel,
} from '@material-ui/core'

const bayphoneAcceptTerms = gql`
    mutation bayphoneAcceptTerms(
        $id: String!,
    ) {
    bayphoneAcceptTerms(
        id: $id,
    ) {
            bayphone{
                id
            }
        }
    }
`

export const BayphoneAcceptTermsDialog = (props) => {
    const client = useApolloClient()

    const { t } = props
    const { open, onClose, bayphone, termsAccepted, setTermsAccepted, handleRefresh} = props

    const handleClose = () => {
        setTermsAccepted(false)
        onClose()
    }

    const handleTermsAccept = () => {
        client.mutate({
            mutation: bayphoneAcceptTerms,
            variables : {
                id : bayphone.id
            }
        }).then(
            res => {
                handleClose()
                handleRefresh()
            }
        ).catch(
            err =>{
                //handleErrorMessage(String(err));
            }
        )
    }

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogContentText
                    style={{ whiteSpace: 'pre-line', textAlign: 'justify', color: '#000' }}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bayphone.termsPolicy) }}
                />

                <FormGroup> 
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={termsAccepted}
                                onChange={(e) => setTermsAccepted(e.target.checked)}
                                name="termsAccepted"
                                color="primary"
                            />
                        }
                        label={t('I have read and accept the terms and conditions')}
                    />
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleClose} 
                    color="primary"
                    variant="outlined"
                >
                    {t('Cancel')}
                </Button>
                <Button
                    onClick={() => { handleTermsAccept() }}
                    color="primary"
                    variant="contained"
                    disabled={!termsAccepted}
                >
                    {t('Accept and Sign')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}  
